import React from 'react';
import { approachContent } from '../data/mock';
import { getImageUrl } from '../lib/api';
import { Settings, Battery, Cable, Target } from 'lucide-react';

const ApproachSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-slate-50" id="approach">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="space-y-8">
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 leading-tight">
              {approachContent.title}
            </h2>
            
            <p className="text-lg text-slate-600 leading-relaxed">
              {approachContent.description}
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              <div className="flex items-start space-x-3 p-4 bg-white rounded-lg border border-slate-100">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Target className="w-5 h-5 text-slate-700" />
                </div>
                <div>
                  <h4 className="font-medium text-slate-900">Individuāla pieeja</h4>
                  <p className="text-sm text-slate-500 mt-1">Katram projektam</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 p-4 bg-white rounded-lg border border-slate-100">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Settings className="w-5 h-5 text-slate-700" />
                </div>
                <div>
                  <h4 className="font-medium text-slate-900">Pielāgojumi</h4>
                  <p className="text-sm text-slate-500 mt-1">Pēc prasībām</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 p-4 bg-white rounded-lg border border-slate-100">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Battery className="w-5 h-5 text-slate-700" />
                </div>
                <div>
                  <h4 className="font-medium text-slate-900">Akumulatori</h4>
                  <p className="text-sm text-slate-500 mt-1">Ja saprātīgi</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 p-4 bg-white rounded-lg border border-slate-100">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Cable className="w-5 h-5 text-slate-700" />
                </div>
                <div>
                  <h4 className="font-medium text-slate-900">Vadu risinājumi</h4>
                  <p className="text-sm text-slate-500 mt-1">Ja nepieciešams</p>
                </div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="aspect-square bg-slate-100 rounded-2xl overflow-hidden">
              <img
                src={getImageUrl(approachContent.image)}
                alt={approachContent.altText}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.classList.add('flex', 'items-center', 'justify-center');
                  e.target.parentElement.innerHTML = '<div class="text-slate-400 text-center p-8"><div class="w-20 h-20 mx-auto mb-4 bg-slate-200 rounded-lg flex items-center justify-center"><svg class="w-10 h-10 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"></path></svg></div><span class="text-sm">Pieejas diagramma</span></div>';
                }}
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-slate-800/5 rounded-2xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;
